import { Component, OnInit, ViewChild, Optional, Inject } from '@angular/core';
import { Panel } from 'src/app/model/panel-modal/panel-model';
import { MatTableDataSource, MatDialog, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { PanelAsignService } from 'src/app/shared/panel-assign/panel-assign.service';
import { SelectionModel } from '@angular/cdk/collections';
import { NotificationService } from 'src/app/shared/notification.service';

export interface DialogData {
  panelId: string;
}

@Component({
  selector: 'app-assigned-panel-detsils',
  templateUrl: './assigned-panel-detsils.component.html',
  styleUrls: ['./assigned-panel-detsils.component.scss']
})
export class AssignedPanelDetsilsComponent implements OnInit {
  panelName: string;
  roomNo: string;
  meetingLink: string;
  processName: string;
  processStartDate: string;
  processEndDate: string;
  panelId: string;
  panelDetails: Panel[];
  selectedCandidatePerPanel: any;
  selectedCandidate = [];

  panelMemberListData: MatTableDataSource<any>;
  candidateListData: MatTableDataSource<any>;
  displayedColumns1: string[] = ['position', 'fullName'];
  displayedColumns2: string[] = ['position', 'select', 'candidateName', 'email', 'contactNo'];    //, 'email', 'contactNo', 'address', 'totalMarks', 'scores'

  panelAssign: any;
  assignedCandidate = [];


  constructor(private panelService: PanelService,
    private dialog: MatDialog,
    private panelAssignService: PanelAsignService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<AssignedPanelDetsilsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public element: DialogData,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer) {
      iconRegistry.addSvgIcon(
        'copy-to-clipboard',
        sanitizer.bypassSecurityTrustResourceUrl('assets/img/copy-to-clipboard.svg'));
      iconRegistry.addSvgIcon(
        'open-in-new-tab',
        sanitizer.bypassSecurityTrustResourceUrl('assets/img/open-in-new-tab.svg'));
    this.panelId = element.panelId;
  }

  //for Check Box Selection in a table
  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.candidateListData != null) {
      const numSelected = this.selection.selected.length;
      const numRows = this.candidateListData.data.length;
      return numSelected === numRows;
    }
  }

  onClose() {
    this.dialogRef.close();
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.candidateListData.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    this.getPanelById();
  }
  getPanelById() {
    this.panelService.findById(this.panelId).then(
      panelDetails => {
        this.panelName = panelDetails.panelName;
        this.roomNo = panelDetails.roomNo;
        this.meetingLink = panelDetails.meetingLink;
        this.processName = panelDetails.processName
        this.processStartDate = panelDetails.processStartDate;
        this.processEndDate = panelDetails.processEndDate;
        this.candidateListData = new MatTableDataSource(panelDetails.panelCandidates);
        this.panelMemberListData = new MatTableDataSource(panelDetails.panelPanelMembers);
        this.candidateListData.sort = this.sort;
        // console.log(panelDetails);
      },
      err => {
        console.log(err);
      }
    );
  }

  notification() {
    let allSelectedCandidateObject = this.selection.selected;
    let candidateIdArray = [];
    let jsonObject = {};
    // jsonObject['candidateIds'] = candidateIdArray;
    // allSelectedCandidateObject.forEach(object => {
    //   candidateIdArray.push(object.candidateId);
    //   this.panelService.notificationEmailAndSmsForCandidate(jsonObject, this.panelId);
    //   this.notificationService.success('Successfully sent Notification to Candidates');
    // });
    jsonObject['candidateIds'] = candidateIdArray;
    allSelectedCandidateObject.map(result => {
      candidateIdArray.push(result.candidateId);
    });
    this.panelService.notificationEmailAndSmsForCandidate(jsonObject, this.panelId)
    .then(res => {
      this.notificationService.success('Successfully sent notifications to candidates');
    },
    err => {
      this.notificationService.warn('Notifications did not sent successfully, Try again later');
    })
    
  }

  copyToClipboard(text: string) {
    const selBox = document.createElement('textarea');

    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox); 

    this.notificationService.success("Copied to clipboard");
  }

  openInNewTab(link: string) {
    window.open(link, '_blank');
  }

}
